var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9151_67)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 87.5,
    r: 87.5,
    fill: "#242426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9023 100.1L73.349 122.126C74.1848 122.131 75.0106 121.943 75.7628 121.576C76.5149 121.208 77.1732 120.672 77.6869 120.007L88.1055 109.968L109.738 125.905C113.678 128.138 116.463 126.974 117.543 122.241L131.731 55.2092C132.981 49.3115 129.685 46.9448 125.745 48.4335L42.3963 80.5941C36.6376 82.8844 36.7702 86.0909 41.4302 87.5606L62.7599 94.2408L110.742 66.0121C113.072 64.4279 115.213 65.3059 113.47 66.8519L74.9023 100.1Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9151_67"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.ef2bdd963d6c3f9a1fbd90495aca8aff.svg";
export { ForwardRef as ReactComponent };